import React from 'react'

import PropTypes from 'prop-types'
import {withRouter} from 'react-router'

import styles from './styles.css'
import Loading from 'orionsoft-parts/lib/components/Loading'

import autobind from 'autobind-decorator'
import {logout} from 'App/helpers/meteor-apollo-accounts'
import {withApollo} from 'react-apollo'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'

@withMutation(gql`
  mutation authorizeSession($code: String) {
    authorizeSession(code: $code) {
      success
    }
  }
`)
@withRouter
@withApollo
export default class VerifyLogin extends React.Component {
  
  state = {
    isLoading: true,
    errMessage: ''
  }

  static propTypes = {
    router: PropTypes.object,
    authorizeSession: PropTypes.func
  }

  async componentDidMount() {
    const pathname = window.location.pathname
    const code = pathname.replace('/verify-login/', '')

    try {
      const response = await this.props.authorizeSession({code}, {refetchQueries: ['getMe']})

      if(response.authorizeSession.success) {
        this.props.router.push('/accounts')
      }
    } catch (err) {
      this.setState({errMessage: err.message.replace(/GraphQL error: (.*) \[.*\]/g, '$1')})
      this.setState({isLoading: false})
    }
  }

  @autobind
  async logout() {
    this.setState({logginOut: true})
    await logout(this.props.client)
    this.props.router.push('/login')
  }

  render() {
    if (this.state.error) {
      return <div className="center-align">{this.state.error}</div>
    } else {
      return (
        <div className={styles.container}>
          <h2 className="tds-orionx-font-dm__h5">
            Validando Login
          </h2>
          <div className="center-align">
            {this.state.isLoading && <Loading />}
            {this.state.errMessage !== '' &&
              <div>
                <p className={styles.errMessage}>
                  {this.state.errMessage}
                  <br />
                </p>
                <p>
                  <a onClick={this.logout} loading={this.state.logginOut}>
                    Cancelar inicio de sesión
                  </a>
                </p>
              </div>
            }
          </div>
          <br />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Root/ApolloError/UnauthorizedSession/VerifyLogin/index.js